import { useState, useEffect } from 'react';
import { TransitionState } from './types.js';
import { usePrevious } from './usePrevious.js';

function useTransitionState(nextValue, delay) {
  var previousValue = usePrevious(nextValue);
  var _useState = useState(TransitionState.hidden),
    transitionState = _useState[0],
    setTransitionState = _useState[1];
  useEffect(function () {
    if (previousValue && nextValue) {
      setTransitionState(TransitionState.entering);
    }
    if (previousValue === false && nextValue === true) {
      setTransitionState(TransitionState.entering);
    }
    if (previousValue === true && nextValue === false) {
      setTransitionState(TransitionState.leaving);
    }
    var finalState = setTimeout(function () {
      setTransitionState(function (currentState) {
        return currentState === TransitionState.entering ? TransitionState.visible : TransitionState.hidden;
      });
    }, delay);
    return function () {
      clearTimeout(finalState);
    };
  }, [nextValue, delay, previousValue]);
  return transitionState;
}

export { useTransitionState };
